import { connect } from "react-redux";
import React, { Component } from "react";
import {
  DEBIT_CARD_ONLINE_BANKING,
  HTTP_STATUS,
} from "../Communication/Constants";
import { QuestionCircle } from "react-bootstrap-icons";
import STRINGS from "../Constants/Strings";
import PasswordInput from "../Components/Common/PasswordInput/PasswordInput";
import AuthBody from "../Components/Common/AuthBody/AuthBody";
import checkErrors from "../Utils/InputValidator";
import VALIDATIONS from "../Constants/ValidationList";
import { usernameCredentials } from "../Utils/CommonUtilities";
import MODALMESSAGES from "../Constants/Messages";
import AppConstants from "../Constants/AppConstants";
import PopupModal from "../Components/AboutYou/PopupKyc";

export class BranchSignin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      username: "",
      password: "",
      showReset: false,
      modal: {
        title: "",
        description: "",
      },
      errors: {
        usernameErrorList: [],
        passwordErrorList: [],
        bankIdErrorList: [],
      },
    };

    this.userNameInput = React.createRef();
  }

  componentDidMount() {}

  verifyData = () => {
    const { username, password, errors } = this.state;

    let usernameErrors = checkErrors(username, VALIDATIONS.SIGNIN.username);
    if (
      usernameErrors &&
      usernameErrors.length > 0 &&
      usernameErrors[0].startsWith("Enter valid")
    ) {
      usernameErrors = [STRINGS.BRANCH.SIGNIN.ERROR_MESSAGES.USERNAME_INVALID];
    }

    let passwordErrors = checkErrors(password, VALIDATIONS.SIGNIN.password);

    this.setState({
      errors: {
        ...errors,
        usernameErrorList: usernameErrors,
        passwordErrorList: passwordErrors,
      },
    });

    return usernameErrors.length + passwordErrors.length;
  };

  handleSubmit = (e) => {
    e.preventDefault();
    const { username, password } = this.state;
    const { handleSignin } = this.props;
    const errors = this.verifyData();
    if (!errors) {
      this.setState({ password: "" }, () => {
        const userDetails = {
          credential: usernameCredentials(username),
          password,
          isChecked: false,
          bankingType: "staff",
          bankId: null,
          checkDuplicate: false,
        };
        handleSignin(userDetails);
      });
    }
  };

  handleEmailKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      this.handleSubmit(event);
    }
  };

  handlePasswordKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      this.handleSubmit(event);
    }
  };

  processForgotPasswordFLow = () => {
    const { username } = this.state;
    const { doAddUserName, doForgotPassword, bankingType } = this.props;
    doAddUserName(username);
    const userDetails = {
      credential: username,
      otpTo: STRINGS.FORGOTPASSWORD.OTP_TO.EMAIL,
      bankingType,
      jointApplicationId: null,
      jointApplicantSlot: null,
    };
    doForgotPassword(userDetails, (forgotResponse) => {
      if (forgotResponse.status === HTTP_STATUS.OK) {
        this.showResetMessage();
      }
    });
  };

  showResetMessage = () => {
    this.setState({
      showReset: true,
      modalType: AppConstants.MODALTYPE.INFORMATION,
      modal: {
        title: MODALMESSAGES.FORGOT_PASSWORD.SUCCESS_MAIL,
        description: STRINGS.FORGOTPASSWORD.MODAL.SSO,
      },
    });
  };

  changeHandler = (event) => {
    const { errors } = this.state;
    const errorObject = `${event.target?.name}${STRINGS.COMMON.ERROR_LIST}`;
    this.setState({
      [event.target.name]: event.target.value,
      errors: {
        ...errors,
        [errorObject]: [],
      },
    });
  };

  render() {
    const { finInfo } = this.props;
    const {
      username,
      password,
      errors,
      showReset,
      modalType,
      modal,
    } = this.state;

    const signInComponent = (
      <form
        className="[ signin-container ]"
        aria-labelledby="signin-title"
        onSubmit={this.handleSubmit}
      >
        <h1 id="signin-title" className="[ form-title-signin ]" tabIndex="0">
          {STRINGS.BRANCH.SIGNIN.VAULTSIGNINTITLE.replace(
            "_BANKING_TYPE_",
            "STAFF"
          )}
        </h1>

        <div className="[ form-container ]">
          {/* Username Field */}
          <div className="[ mb-3 ]">
            <label
              htmlFor="username"
              className="[ form-label ]"
              aria-label={STRINGS.BRANCH.SIGNIN.FORM.USERNAME_LABEL}
            >
              {STRINGS.BRANCH.SIGNIN.FORM.USERNAME_LABEL}
            </label>

            <input
              id="username"
              type="email"
              name="username"
              className={
                errors?.usernameErrorList.length > 0
                  ? "[ form-control ] [ invalid-input ]"
                  : "[ form-control ]"
              }
              placeholder={STRINGS.BRANCH.SIGNIN.FORM.EMAIL_PLACEHOLDER}
              aria-required="true"
              aria-invalid={errors?.usernameErrorList.length > 0}
              aria-describedby="username-error"
              value={username}
              onChange={this.changeHandler}
              onKeyDown={this.handleEmailKeyDown}
              ref={this.userNameInput}
            />
            <div
              id="username-error"
              className="[ error-msg ]"
              aria-live="polite"
            >
              <span>
                {errors?.usernameErrorList[0] &&
                  (errors?.usernameErrorList[0].startsWith("Please enter Email")
                    ? STRINGS.BRANCH.SIGNIN.ERROR_MESSAGES.REQUIRED_FIELD
                    : errors?.usernameErrorList[0])}
              </span>
            </div>
          </div>

          {/* Password Field */}
          <div className="[ mb-3 ]">
            <label
              htmlFor="password"
              className="[ form-label ]"
              aria-label={STRINGS.BRANCH.SIGNIN.FORM.PASSWORD_LABEL}
            >
              {STRINGS.BRANCH.SIGNIN.FORM.PASSWORD_LABEL}
            </label>

            <PasswordInput
              id="password"
              changeHandler={this.changeHandler}
              password={password}
              passwordError={errors?.passwordErrorList}
              placeholder={STRINGS.BRANCH.SIGNIN.FORM.PASSWORD_PLACEHOLDER}
              onKeyDownHandler={this.handlePasswordKeyDown}
              aria-required="true"
              aria-invalid={errors?.passwordErrorList.length > 0}
            />

            <div
              id="password-error"
              className="[ error-msg ]"
              aria-live="polite"
            >
              <span>
                {errors?.passwordErrorList[0] &&
                  (errors?.passwordErrorList[0].startsWith(
                    "Please enter Password"
                  )
                    ? STRINGS.BRANCH.SIGNIN.ERROR_MESSAGES.REQUIRED_FIELD
                    : errors?.passwordErrorList[0])}
              </span>
            </div>
          </div>

          {/* Forgot Password */}
          <div className="[ mb-3 ]">
            <div className="[ row ] [ align-items-center ]">
              <div className="[ col-6 ] [ d-flex align-items-center ] [ checkbox ]" />
              <div className="[ col-6 ] [ forgot-link ]">
                <button
                  type="button"
                  className="[ link ]"
                  onClick={this.forgotPasswordHandler}
                  aria-label={STRINGS.BRANCH.SIGNIN.FORM.FORGOTPASSWORD_LINK}
                >
                  {STRINGS.BRANCH.SIGNIN.FORM.FORGOTPASSWORD_LINK}
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Submit Button */}
        <div className="[ mb-3 ]">
          <div className="[ row ]">
            <div className="[ col-lg-6 ] [ offset-lg-3 ]">
              <button
                type="submit"
                className="[ submit-btn btn ] [ w-100 ]"
                style={{
                  borderRadius: ".5em",
                  backgroundColor: "#01aeef",
                  color: "#fff",
                }}
                aria-label={STRINGS.BRANCH.SIGNIN.FORM.BUTTON_SIGNIN}
              >
                {STRINGS.BRANCH.SIGNIN.FORM.BUTTON_SIGNIN}
              </button>
            </div>
          </div>
        </div>
      </form>
    );

    const infoComponent = (
      <div
        className="[ form-container ]"
        style={{
          backgroundImage: "url('/teller.jpg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
        role="region"
        aria-label={STRINGS.BRANCH.SIGNIN.SUBTITLE}
      >
        <div className="[ mb-3 ]">
          <center>
            <div className="[ logo ]" role="img" aria-label="Bank logo" />
          </center>
        </div>

        <div className="[ mb-3 ]">
          <h4 style={{ textAlign: "center" }}>
            {finInfo?.name} - {STRINGS.BRANCH.SIGNIN.TITLE} -{" "}
            {STRINGS.BRANCH.SIGNIN.SUBTITLE}
          </h4>
        </div>

        <div className="[ mb-3 ]">
          <center>
            {STRINGS.BRANCH.SIGNIN.WELCOME_TEXT.replace(
              "_BANK_NAME_",
              finInfo?.name || ""
            )}
          </center>
        </div>
      </div>
    );

    return (
      <>
        {showReset && (
          <PopupModal
            type={modalType}
            title={modal.title}
            description={modal.description}
            toggleModal={this.toggleReset}
            showModal={showReset}
            btnText={STRINGS.POPUPMODAL.OKBUTTON}
          />
        )}
        <AuthBody
          actionComponent={signInComponent}
          infoComponent={infoComponent}
          securityText={STRINGS.INFOBANNER.SECURESESSIONTEXT}
          showNavigationBar={false}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => ({});

export default connect(mapStateToProps, {})(BranchSignin);
